export var PaymentProviders = {
  EWAY: 'eway',
  CAMS: 'cams'
};